var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { PureComponent } from "react";
import Loading from "@irati/ui/src/Loading";
import { connect } from "@irati/store";
import authentication from "@irati/auth";
import LangActions from "./store/actions";
var LangLoader = /** @class */ (function (_super) {
    __extends(LangLoader, _super);
    function LangLoader(props) {
        var _this = _super.call(this, props) || this;
        _this.loadContent = function () {
            var _a = _this.props, getContent = _a.getContent, forceUpdate = _a.forceUpdate;
            var buckets = _this.getBucketsToLoad();
            return getContent(buckets, _this.getLocale(), forceUpdate);
        };
        _this.getBucketsToLoad = function () {
            var _a = _this.props, bucket = _a.bucket, buckets = _a.buckets;
            if (bucket)
                return [bucket];
            return buckets;
        };
        _this.getLocale = function () {
            return authentication.userLocale();
        };
        _this.state = {
            load: _this.loadContent()
        };
        return _this;
    }
    LangLoader.prototype.render = function () {
        var load = this.state.load;
        return React.createElement(Loading, __assign({}, this.props, { load: load }));
    };
    LangLoader.defaultProps = {
        bucket: null,
        buckets: [],
        forceUpdate: false
    };
    return LangLoader;
}(PureComponent));
var mapStateToProps = function (_a) {
    var auth = _a.auth;
    return ({ auth: auth });
};
export var actions = function (dispatch) {
    return {
        getContent: function (buckets, locale, forceUpdate) { return dispatch(LangActions.get(buckets, locale, forceUpdate)); }
    };
};
export default connect(mapStateToProps, actions)(LangLoader);
